import ServiceFamily, {IServiceFamily} from "@/model/ServiceFamily/ServiceFamily"

export interface IGlobalServiceFamily extends IServiceFamily {

}

class GlobalServiceFamily extends ServiceFamily implements IGlobalServiceFamily {

    constructor(id: string) {
        super(id)
    }
}

export default GlobalServiceFamily